import { render, staticRenderFns } from "./RqtaEditAbout.vue?vue&type=template&id=58d2ae2e&scoped=true&"
import script from "./RqtaEditAbout.vue?vue&type=script&lang=js&"
export * from "./RqtaEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2ae2e",
  null
  
)

export default component.exports